import { fetchAuthxRefreshKeyAndPersistSec2 } from "./authx-sec2";

/** Po udanym refresh-key (np. wake) — inne moduły mogą nasłuchiwać. */
export const OLIVS_SESSION_REFRESHED_EVENT = "olivs:session-refreshed";

let coalescedRefresh = null;

/** Jedno równoległe POST refresh-key. */
export function refreshAuthxSessionCoalesced() {
  if (!coalescedRefresh) {
    coalescedRefresh = fetchAuthxRefreshKeyAndPersistSec2().finally(() => {
      coalescedRefresh = null;
    });
  }
  return coalescedRefresh;
}

export function dispatchSessionRefreshed() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(OLIVS_SESSION_REFRESHED_EVENT));
  }
}
